var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{staticClass:"header-logo",attrs:{"src":_vm.logoPath,"alt":""}}),_c('ReferralForm',{attrs:{"id":_vm.referralFormId,"border-color":"black"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }